import { CurrentUser, Community, Role } from 'src/types';

export const userIsMemberOfCurrentGroup = (user: CurrentUser | null, community: Community | null) => {
  if (!user || !community) return false;
  const userGroups = user.followedCommunities || [];
  const userGroupIds = userGroups.map(grp => grp.communityId);
  return userGroupIds.includes(community.communityId);
};

export const userHasRole = (user: CurrentUser | null, role: Role | Role[]) => {
  if (!user) return false;
  if (typeof role === 'string') {
    return user?.roles?.includes(role);
  } else {
    return user?.roles?.some(r => role.includes(r));
  }
};


export const userHasPermission = (user: CurrentUser | null, permission: string) => {
  if (!user) return false;
  return user?.permissions?.includes(permission);
};
